module.exports = __webpack_public_path__ + "img/nodata.5d5621e0.png";